import { Component, Input, OnInit } from '@angular/core';
import { BusinessCitationService } from '../../../../services/business-citation.service';
import { finalize, map } from 'rxjs/operators';
import { LocalProfileService } from '../../../../services/local-profile.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-components-shared-business-citation-subscriptions',
  templateUrl: './business-citation-subscriptions.component.html',
  styleUrls: ['./business-citation-subscriptions.component.scss']
})
export class BusinessCitationSubscriptionsComponent implements OnInit {
  @Input() customerId: number;
  @Input() allowValidationAndAugmentationOrdering = false;
  @Input() showSaveButton = false;

  isLoading = false;
  localProfiles: Boo.Objects.LocalProfiles.LocalProfileFragment[];
  tasks: Boo.Objects.TaskFragment[];
  businessCitationSubscriptions: Boo.BusinessCitations.Models.BusinessCitationSubscriptionFragment[];

  boostabilityProviderId: Boo.BusinessCitations.Models.Enums.Providers = Boo.BusinessCitations.Models.Enums.Providers.Boostability;
  uberallProviderId: Boo.BusinessCitations.Models.Enums.Providers = Boo.BusinessCitations.Models.Enums.Providers.Uberall;
  activeSubscriptionStatusId: Boo.BusinessCitations.Models.Enums.SubscriptionStatuses = Boo.BusinessCitations.Models.Enums.SubscriptionStatuses.Active;

  constructor(private businessCitationService: BusinessCitationService,
    private localProfileService: LocalProfileService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.load()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({ error: (err) => toastr.error(err) });
  }

  load(): Observable<void> {
    return this.businessCitationService.getBusinessCitationSubscriptionSummary(this.customerId, this.allowValidationAndAugmentationOrdering)
      .pipe(
        map(summary => {
          this.localProfiles = summary.LocalProfiles.sort(this.localProfileService.sortFragments.bind(this));
          this.tasks = summary.Tasks;
          this.businessCitationSubscriptions = summary.LocalProfiles.filter(x => x.BusinessCitationSubscription).map(x => x.BusinessCitationSubscription);
        })
      );
  }

  openProviderSSO(localProfileId: number): void {
    this.businessCitationService.generateBusinessCitationProviderSSOUrl(localProfileId)
      .subscribe(
        ssoUrl => {
          window.open(ssoUrl, '_blank');
        },
        (err) => toastr.error(err));
  }

  orderValidationAndAugmentation(localProfile: Boo.Objects.LocalProfiles.LocalProfileFragment) {
    bootbox.dialog({
      message: 'Would you like to order a Business Profile Validation and Augmentation task for this local profile?',
      closeButton: false,
      buttons: {
        yes: {
          label: 'Yes',
          className: 'btn-success',
          callback: (): void => {
            localProfile.ValidationAndAugmentationStatus.CanOrder = false;
            localProfile.ValidationAndAugmentationStatus.Reason = 'In progress';

            this.businessCitationService.orderValidationAndAugmentation(this.customerId, localProfile.LocalProfileId)
              .subscribe(_ => toastr.info('Validation and Augmentation ordered'), (err) => toastr.error(err));
          }
        },
        no: {
          label: 'No',
          className: 'btn-danger'
        }
      }
    });
  }
}